export default "__VITE_ASSET__Ck2GPXF___"